import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import NEW_API from "../../../Api/NewApi";
import Select from "../../Common/FormElements/Select/Select";
import TextInput from "../../Common/FormElements/TextInput/TextInput";
import Button from "../../Common/FormElements/Button/Button";
import { closeCenteredModal } from "../../../REDUX/actions/centeredModal";
import { openRightModal } from "../../../REDUX/actions/rightModal";
import { createProject } from "../../../REDUX/actions/appProjects";
import ProjectModal from "./ProjectModal";

/**
 * Slide-4 popup: pick an existing prospect account (autocomplete), then the
 * created project opens directly in its Général page.
 */
const AddProjectModal = () => {
  const dispatch = useDispatch();
  const { t } = useTranslation("common");
  const { createLoading } = useSelector((state) => state.appProjectsReducer);
  const [customers, setCustomers] = useState([]);
  const [customer, setCustomer] = useState(null);
  const [name, setName] = useState("");

  useEffect(() => {
    const controller = new AbortController();
    (async () => {
      try {
        const { data } = await NEW_API.get("/api/customers", {
          params: { page: 1, pageSize: 1000 },
          signal: controller.signal,
        });
        setCustomers(
          (data?.data ?? []).map((row) => ({
            name:
              `${row.firstName ?? ""} ${row.lastName ?? ""}`.trim() ||
              row.username ||
              row.email,
            code: row.id,
          }))
        );
      } catch (error) {
        if (error.name === "CanceledError" || error.code === "ERR_CANCELED")
          return;
        console.log(error);
      }
    })();
    return () => controller.abort();
  }, []);

  const handleCreate = () => {
    dispatch(
      createProject(
        { userId: customer?.code, name: name || undefined },
        t,
        (project) => {
          dispatch(closeCenteredModal());
          dispatch(openRightModal(<ProjectModal projectId={project?.id} />));
        }
      )
    );
  };

  return (
    <div className="p-4 bg-white br10" style={{ minWidth: 420 }}>
      <h3 className="text-blue bold f18 quickSand mb-3">
        {t("Add a project")}
      </h3>
      <div className="mb-3">
        <label className="f16 text-softBlack sBold mb-1">{t("Prospect")}</label>
        <Select
          filter
          placeholder={t("Prospect")}
          options={customers}
          value={customer}
          callback={(e) => setCustomer(e.value ?? null)}
          appendToSelf
        />
      </div>
      <div className="mb-4">
        <label className="f16 text-softBlack sBold mb-1">
          {t("Project name")}
        </label>
        <TextInput
          placeholder={t("Project name")}
          value={name}
          callback={(e) => setName(e.target.value)}
        />
      </div>
      <div className="d-flex justify-content-end gap-3">
        <Button variant="outline" onClick={() => dispatch(closeCenteredModal())}>
          {t("Cancel")}
        </Button>
        <Button
          loading={createLoading}
          disabled={!customer}
          onClick={createLoading ? undefined : handleCreate}
        >
          {t("Validate")}
        </Button>
      </div>
    </div>
  );
};

export default AddProjectModal;
